module.exports = __webpack_public_path__ + "img/21.0acb5b22.jpg";